module.exports = __webpack_public_path__ + "img/ic_3.4276331e.png";